var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkIfVLM())?_c('div',[(_vm.isReady)?_c('Window'):_vm._e(),_c('AboutVlm')],1):_c('div',[(_vm.isReady)?_c('Window'):_vm._e(),_c('About')],1)}
var staticRenderFns = []

export { render, staticRenderFns }